import { forEach } from 'lodash';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { BodegaService } from 'src/app/services/bodega.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { AnalisisDemandaModalDetalleMovimientosComponent } from './modal-detalle-movimientos/modal-detalle-movimientos.component';
import { AnalisisDemandaModalCambioProductoComponent } from './modal-cambio-producto/modal-cambio-producto.component';
import { AnalisisDemandaModalPedidosComponent } from './modal-pedidos/modal-pedidos.component';
import { DocumentoNoTributarioService } from 'src/app/services/documento-no-tributario.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { AnalisisDemandaService } from 'src/app/services/analisis-demanda.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { UnidadNegocioService } from 'src/app/services/unidad-negocio.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { EditarNotaVentaComponent } from './editar-nota-venta/editar-nota-venta.component';
import { NotaVentaService } from 'src/app/services/nota-venta.service';
import Swal from 'sweetalert2';
import { OnExit } from 'src/app/shared/guards/can-deactivate.guard';
import { ModalVerErroresComponent } from '../../shared/modal-ver-errores/modal-ver-errores.component';

export enum EstadoAnalisisCodigo {
  Atendido = 0,
  AtendidoPadre = 1,
  NoAtendido = 2,
  Quiebre = 3
}

@Component({
  selector: 'app-analisis-demanda',
  templateUrl: './analisis-demanda.component.html',
  styleUrls: ['./analisis-demanda.component.scss'],
  providers: [SecurityService],
})
export class AnalisisDemandaComponent implements OnInit, OnExit {
  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = '_RB_TIPO_VISTA_RESUMEN_';
  readonly RB_TIPO_VISTA_DETALLE: String = '_RB_TIPO_VISTA_DETALLE_';

  // Modales
  @ViewChild(AnalisisDemandaModalDetalleMovimientosComponent, { static: true }) modalDetalleMov: AnalisisDemandaModalDetalleMovimientosComponent;
  @ViewChild(AnalisisDemandaModalCambioProductoComponent, { static: true }) modalCambioProducto: AnalisisDemandaModalCambioProductoComponent;
  @ViewChild(AnalisisDemandaModalPedidosComponent, { static: true }) modalPedidos: AnalisisDemandaModalPedidosComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;
  @ViewChild(EditarNotaVentaComponent, { static: true }) notaVenta: EditarNotaVentaComponent;
  @ViewChild(ModalVerErroresComponent, { static: true }) modalVerErrores: ModalVerErroresComponent;

  // Form
  formHeader: FormGroup;

  // Data & tmp
  private rutEmpresa: number;
  private sucursalCodigo: number;
  optionsBodega: Array<any> = [];
  loading: boolean = false;
  listaMovimientos: Array<any> = null;
  listaMovimientosAll: Array<any> = null;
  ResumenListaMovimientoAll: Array<any> = null;
  ResumenlistaAll: Array<any> = null;
  listaMovimientosResumen: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext();
  paginationContextResumen: PaginationContext = new PaginationContext();
  currentAnalisisPayload: any = null;
  processing: boolean = false;
  sumTotalAt: number = 0;
  sumTotalQuiebre: number = 0;

  //variable Nota Venta Especifica
  seleccionNotaVentaEsp: any = null;

  // Unidad de negocio
  optionsUnidadesDeNegocio: unidad_negocio[] = [];
  public permiteUnidadNegocio: boolean = false;

  // Utils
  private log: any;
  CheckBoxAllValue: boolean = true;
  CheckBoxAllValueResumen: boolean = true;
  groupArr: any;
  modalConfirmTitle: String = '';
  modalConfirmContent: String = '';
  showEdit: boolean = false;
  folio: number = 0;
  ValidateNotaVenta: boolean = false;
  ConfirmacionNota: boolean = false;

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private bodegaService: BodegaService,
    private analisisDemandaService: AnalisisDemandaService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private documentoNoTributarioService: DocumentoNoTributarioService,
    private datesService: DatesService,
    private fileDownloadService: FileDownloadService,
    public router: Router,
    private parametroEmpresaService: ParametroEmpresaService,
    private unidadNegocioService: UnidadNegocioService,
    private rutService: RutService,
    private notaventaService: NotaVentaService
  ) {
    this.log = this.clog.log('ANALISIS-DEMANDA');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;
    this.paginationContextResumen.RecordsByPage = 10;

    this.createForm();
    this.loadBodegas();
    this.checkUnidadNegocio();
  }

  async OnExit() {
    if (this.ValidateNotaVenta == true) {
      //   this.modalConfirmTitle = "Duplicar descuento"
      // this.modalConfirmContent = "¿Desea duplicar el descuento?"
      // const a = this.modalConfirm.show(() => {return true});

      // return a;
      const result = await Swal.fire({
        title: '¿Esta seguro que desea salir de la página?',
        text: 'tus modificaciones se guardarán automaticamente.\n ¿Desea continuar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.notaVenta.CloseNotaVenta();
          this.ConfirmacionNota = result.isConfirmed;
          return this.ConfirmacionNota;
        } else {
          this.ConfirmacionNota = false;
          return this.ConfirmacionNota;
        }
      });

      return result;
    } else {
      this.ValidateNotaVenta = false;
      return true;
    }
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      bodega: [null],
      unidad_negocio_codigo: [null, []],
    });
  }

  private loadBodegas() {
    this.bodegaService.GetBodegas(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsBodega = registros.map((bodega) => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega);
    });
  }

  checkUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(Number(this.rutEmpresa), ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteUnidadNegocio = respuesta.valor_bool;

      if (this.permiteUnidadNegocio) {
        this.loadUnidadNegocio();
      }
    });
  }

  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        tipo: 1,
      },
    };
    this.optionsUnidadesDeNegocio = [];
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsUnidadesDeNegocio = registros.map((unidad_negocio) => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre,
      }));
      this.AddUnidadDeNegocioValidators();
    });
  }

  AddUnidadDeNegocioValidators() {
    // this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('unidad_negocio_codigo'), this.optionsUnidadesDeNegocio)
    this.formHeader.get('unidad_negocio_codigo').setValidators([Validators.required]);
    this.formHeader.get('unidad_negocio_codigo').updateValueAndValidity();
  }

  buscar(pageNumber: number) {
    this.currentAnalisisPayload = null;
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) return;

    this.paginationContext.CurrentPage = pageNumber;
    this.paginationContextResumen.CurrentPage = pageNumber;

    //** DECLARACION VARIABLE PARA DETALLE */

    this.listaMovimientosAll = null;
    this.groupArr = null;

    //** DECLARACION VARIABLE PARA RESUMEN */
    this.listaMovimientosResumen = [];
    this.ResumenListaMovimientoAll = [];
    this.ResumenlistaAll = [];

    const { fechaDesde, fechaHasta, bodega, unidad_negocio_codigo } = this.formHeader.value;

    const inputParams = {
      empresa_rut: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      // fechaDesde: this.formHeader.get('fechaDesde').value,
      // fechaHasta: this.formHeader.get('fechaHasta').value,
      // codigoBodega: this.formHeader.get('bodega').value,
      fechaDesde,
      fechaHasta,
      codigoBodega: bodega,
      unidadNegocio: this.permiteUnidadNegocio ? unidad_negocio_codigo : 0,
      rutUsuario: this.accesolocalstorage.getRutUsuario(),
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };

    this.currentAnalisisPayload = inputParams;

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.documentoNoTributarioService.ObtenerResultadoAnalisis(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { registros } = respuesta;
      this.listaMovimientosAll = registros;

      this.listaMovimientosAll.forEach((mov, index) => {
        mov.additionalInfo = {};
        mov.additionalInfo.index = index;
        mov.additionalInfo.checked = true;
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
      });

      if (registros.length > 0) {
        //*LISTA DETALLE CON AGRUPACION DE DOCUMENTOS
        const groupDetalle = _.cloneDeep(this.listaMovimientosAll);
        this.groupArr = groupDetalle.reduce((r, { skuProducto }) => {
          if (!r.some((o) => o.skuProducto == skuProducto)) {
            r.push({
              skuProducto,
              nombreProducto: groupDetalle.find((x) => x.skuProducto === skuProducto).nombreProducto,
              index: skuProducto,
              groupItem: groupDetalle.filter((v) => v.skuProducto == skuProducto),
            }).detalleAnalisisDemanda;
          }

          return r;
        }, []);
      }

      if (this.groupArr) {
        this.groupArr.map((pedido, index) => {
          pedido.additionalInfo = {};
          pedido.additionalInfo.index = index;
          pedido.additionalInfo.checked = true;
        });
      }

      //* CREANDO LA LISTA RESUMEN
      this.ResumenListaMovimientoAll = _.cloneDeep(this.listaMovimientosAll);

      // const distinctIds = [];
      // this.ResumenListaMovimientoAll.forEach(entry =>{
      //     const {skuProducto, nombreProducto, cantidadRequerida, cantidadAtendida, estado, estadocodigo, folio, producto_codigo, stock_Actual, stock_tras_movimiento} = entry;
      //     const data = {cantidadAtendida, estado, estadocodigo, folio, producto_codigo, stock_Actual, stock_tras_movimiento};
      //     const exists = distinctIds.find(y => y.skuProducto === entry.skuProducto)
      //     if (!exists){
      //         distinctIds.push({skuProducto, nombreProducto, cantidadRequerida, data: [data]})
      //     }else {
      //         exists.data.push(data)
      //     }
      // } )

      const listaResumen = this.ResumenListaMovimientoAll.map((doc) => {
        const params = {
          skuProducto: doc.skuProducto,
          descripcion: doc.nombreProducto,
          cantidad: doc.cantidadRequerida,
          formato: doc.nombreFormato,
          estado: doc.estado,
          estadoAnalisisCodigo: doc.estadoAnalisisCodigo,
          detalleAnalisisDemanda: doc.detalleAnalisisDemanda,
          // El quiebre del resumen solo debe acumular el faltante de las filas en Quiebre.
          // En filas Atendido, diferenciaConStock es el sobrante de stock, no un faltante.
          diferenciaConStock:
            doc.estadoAnalisisCodigo === EstadoAnalisisCodigo.Quiebre ? doc.diferenciaConStock : 0,
        };

        return params;
      });

      //* LISTA ALL SIN DUPLICADOS Y CON SUMATORIA DE CANTIDAD
      const ListaSinDuplicados = listaResumen.reduce((acumulador, valorActual) => {
        const elementoYaExiste = acumulador.find((elemento) => elemento.skuProducto === valorActual.skuProducto && elemento.formato === valorActual.formato);
        if (elementoYaExiste) {
          return acumulador.map((elemento) => {
            if (elemento.skuProducto === valorActual.skuProducto && valorActual.diferenciaConStock >= 0 && elemento.diferenciaConStock >= 0) {
              return {
                ...elemento,
                cantidad: elemento.cantidad + valorActual.cantidad,
                diferenciaConStock: elemento.diferenciaConStock + valorActual.diferenciaConStock,
                detalle: elemento.detalleAnalisisDemanda,
              };
            }

            return elemento;
          });
        }

        return [...acumulador, valorActual];
      }, []);

      this.ResumenlistaAll = ListaSinDuplicados;

      this.ResumenlistaAll.forEach((mov, index) => {
        mov.additionalInfo = {};
        mov.additionalInfo.index = index;
        mov.additionalInfo.checked = true;
      });

      // Calcula total atendido: completos + parciales (lo que sí se pudo atender del quiebre)
      const sumAllAtendidos = this.listaMovimientosAll.reduce((sum, actual) => {
        if (actual.estadoAnalisisCodigo == EstadoAnalisisCodigo.Atendido || 
            actual.estadoAnalisisCodigo == EstadoAnalisisCodigo.AtendidoPadre) {
          // Completamente atendido
          return sum + actual.cantidadRequerida;
        } else if (actual.estadoAnalisisCodigo == EstadoAnalisisCodigo.Quiebre) {
          // Parcialmente atendido: requerido - quiebre = lo que sí se atendió
          return sum + (actual.cantidadRequerida - actual.diferenciaConStock);
        }
        return sum;
      }, 0);

      // Calcula total quiebre (lo que no se pudo atender)
      const sumallQuiebre = this.listaMovimientosAll.reduce((sum, actual) => (actual.estadoAnalisisCodigo == EstadoAnalisisCodigo.Quiebre ? sum + actual.diferenciaConStock : sum), 0);

      this.sumTotalAt = sumAllAtendidos;
      this.sumTotalQuiebre = sumallQuiebre;

      this.paginationContext.RecordsCount = this.groupArr.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas

      this.paginationContextResumen.RecordsCount = this.ResumenlistaAll.length; //totalRegistros
      this.paginationContextResumen.PagesCount = Math.ceil(this.paginationContextResumen.RecordsCount / this.paginationContextResumen.RecordsByPage); //totalPaginas
      // this.paginationContext.CurrentPage = 1

      this.showPage(this.paginationContext.CurrentPage);
      this.showPageResumen(this.paginationContextResumen.CurrentPage);

      this.loading = false;
    });
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaMovimientos = _.slice(this.groupArr, start, start + this.paginationContext.RecordsByPage);
  }

  showPageResumen(pageNumber: number) {
    this.paginationContextResumen.CurrentPage = pageNumber;
    const start = (this.paginationContextResumen.CurrentPage - 1) * this.paginationContextResumen.RecordsByPage;
    this.listaMovimientosResumen = _.slice(this.ResumenlistaAll, start, start + this.paginationContextResumen.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  onPageChangeResumen(context: PaginationContext) {
    this.showPageResumen(context.RequestedPage);
  }

  checkAllChange({ checked }) {
    //* VISTA DETALLADA
    if (this.formHeader.get('tipoVista').value === this.RB_TIPO_VISTA_DETALLE) {
      this.groupArr.forEach((mov) => {
        mov.additionalInfo.checked = checked;
      });
      this.listaMovimientos.forEach((mov) => {
        mov.additionalInfo.checked = checked;
        mov.groupItem.forEach((item) => {
          item.additionalInfo.checked = checked;
        });
      });
    } else {
      //* VISTA RESUMEN

      this.ResumenlistaAll.forEach((mov) => {
        mov.additionalInfo.checked = checked;
      });
      this.listaMovimientosResumen.forEach((mov) => {
        mov.additionalInfo.checked = checked;
      });
    }
  }

  checkDetalle({ index }, { checked }, event) {
    //* VISTA DETALLADA
    if (this.formHeader.get('tipoVista').value === this.RB_TIPO_VISTA_DETALLE) {
      const { folio, skuProducto } = event;

      // const _indexAll = this.groupArr.findIndex(p => p.additionalInfo.index === index)
      // this.groupArr[_indexAll].additionalInfo.checked = checked

      this.listaMovimientos.forEach((mov) => {
        mov.groupItem.forEach((item) => {
          if (item.additionalInfo.index == index && item.skuProducto == skuProducto) {
            item.additionalInfo.checked = checked;
          }
        });

        const count = mov.groupItem.filter((x) => x.additionalInfo.checked == true);
        if (count.length == mov.groupItem.length) {
          mov.additionalInfo.checked = true;
        } else {
          mov.additionalInfo.checked = false;
        }
      });

      const Cont = this.listaMovimientos.filter((x) => x.additionalInfo.checked == true);
      if (Cont.length < this.listaMovimientos.length) {
        this.CheckBoxAllValue = false;
      } else {
        this.CheckBoxAllValue = true;
      }
    } else {
      //* VISTA RESUMEN
      const _indexAll = this.ResumenlistaAll.findIndex((p) => p.additionalInfo.index === event.additionalInfo.index);
      this.ResumenlistaAll[_indexAll].additionalInfo.checked = checked;

      const _indexPage = this.listaMovimientosResumen.findIndex((p) => p.additionalInfo.index === event.additionalInfo.index);
      this.listaMovimientosResumen[_indexPage].additionalInfo.checked = checked;

      const Cont = this.listaMovimientosResumen.filter((x) => x.additionalInfo.checked == true);
      if (Cont.length < this.listaMovimientosResumen.length) {
        this.CheckBoxAllValueResumen = false;
      } else {
        this.CheckBoxAllValueResumen = true;
      }
    }
  }

  loadAndShowModalDetalleMov(movimiento) {
    this.modalDetalleMov.loadAndShow(movimiento);
  }

  loadAndShowModalCambioProducto(movimiento) {
    this.modalCambioProducto.loadAndShow(
      movimiento,
      this.formHeader.get('bodega').value,
      Number(this.formHeader.get('unidad_negocio_codigo').value) || null
    );
  }

  loadAndShowModalPedidos(detalleMovimiento) {
    if (!detalleMovimiento || detalleMovimiento.length === 0) {
      this.toastService.warning('No existen detalles para este movimiento');
      return;
    }
    this.modalPedidos.loadAndShow(detalleMovimiento[0]);
  }

  obtenerAnalisisExcel(ExcelVistaResumen) {
    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      obtenerResumen: ExcelVistaResumen == true ? true : false,
    };
    this.log('inputParams', JSON.stringify(inputParams));

    //*SE OBTIENE ANALISIS EXCEL DETALLADO O DETALLE
    this.analisisDemandaService.obtenerAnalisisExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta);
    });
  }

  procesarResultadoAnalisis() {
    //*SELECCIONAR DATOS POR LA LISTA RESUMEN
    if (this.formHeader.get('tipoVista').value === this.RB_TIPO_VISTA_RESUMEN) {
      this.listaMovimientosAll.forEach((listaAll) => {
        this.listaMovimientosResumen.forEach((r) => {
          if (listaAll.skuProducto == r.skuProducto && listaAll.nombreFormato == r.formato) {
            listaAll.additionalInfo.checked = r.additionalInfo.checked;
          }
        });
      });
    } else {
      //*SELECCIONAR DATOS POR LA LISTA DETALLE
      const listDetalle = this.listaMovimientos.map((x) => x.groupItem);

      this.listaMovimientosAll.forEach((listaAll) => {
        listDetalle.forEach((det) => {
          det.forEach((element) => {
            if (listaAll.skuProducto == element.skuProducto && listaAll.additionalInfo.index == element.additionalInfo.index) {
              listaAll.additionalInfo.checked = element.additionalInfo.checked;
            }
          });
        });
      });
    }

    const producto_formatoSel = this.listaMovimientosAll
      .filter((p) => p.additionalInfo.checked == true)
      .map((p) => ({
        producto_codigo: p.producto_codigo,
        formato_codigo: p.producto_formato,
      }));

    if (producto_formatoSel.length === 0) {
      this.toastService.warning('Seleccione registro(s)');
      return;
    }

    const { fechaDesde, fechaHasta, codigoBodega, unidadNegocio } = this.currentAnalisisPayload;
    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      fechaDesde,
      fechaHasta,
      codigoBodega,
      unidadNegocio: unidadNegocio || 0,
      rutUsuario: this.accesolocalstorage.getRutUsuario(),
      producto_formatoSel,
    };
    this.log('inputParams', JSON.stringify(inputParams));

    this.processing = true;

    this.documentoNoTributarioService.procesarResultadoAnalisis(inputParams, ({ mensajes, respuesta }) => {
      const esMensajePrecioCeroAfecto = (m: any): boolean => {
        const codigo = m && m.codigo ? String(m.codigo) : '';
        const texto = m && typeof m.texto === 'string' ? m.texto : '';
        const contexto = m && typeof (m as any).contexto === 'string' ? (m as any).contexto : '';

        // No dependemos de m.tipo (que puede venir con distinto casing/serialización).
        // El objetivo es bloquear la navegación cuando el back indica "precio 0" en afecto.
        const codigoLower = codigo.toLowerCase();
        const textoLower = texto.toLowerCase();
        const contextoLower = contexto.toLowerCase();

        return (
          // Por código (evita depender de casing o prefijos exactos)
          codigoLower.includes('precioceroafecto') ||
          codigo.includes('documento_no_tributario.ProcesarResultadoAnalisis.PrecioCeroAfecto') ||
          // Por texto/contexto (evita depender de cuál propiedad trae el back)
          textoLower.includes('precio 0') ||
          textoLower.includes('precio cero') ||
          contextoLower.includes('precio 0') ||
          contextoLower.includes('precio cero')
        );
      };

      const mensajesPrecioCeroAfecto = (mensajes || []).filter(esMensajePrecioCeroAfecto);
      const tieneWarningPrecioCero = mensajesPrecioCeroAfecto.length > 0;
      const errores = (mensajes || []).filter((m) => m && m.tipo === 'ERROR');

      if (mensajes && mensajes.length > 0) {
        // 1) Si hay errores reales, se muestran y se bloquea sin mostrar infos "sin datos".
        if (errores.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          this.processing = false;
          this.loading = false;
          return;
        }

        // 2) Si hay precio 0, mostramos modal y NO mostramos INFO "No se encontraron registros".
        //    Ese INFO es consecuencia de que el back excluye NVs y deja la lista vacía.
        if (tieneWarningPrecioCero) {
          this.modalVerErrores.loadAndShow(mensajesPrecioCeroAfecto);
          this.processing = false;
          this.loading = false;
          return;
        }

        // 3) Solo si no es precio 0: mostramos INFO y warnings normales vía toast y continuamos a confirmación.
        this.messageRendererService.showInfoMessages(mensajes);

        const warningsParaToast = mensajes.filter((m) => m && m.tipo === 'WARNING');
        if (warningsParaToast.length > 0) {
          this.messageRendererService.showWarningMessages(warningsParaToast);
        }
      }

      this.toastService.success('Operación exitosa');
      this.processing = false;

      this.router.navigate(['./facturacion/confirmarNotaVenta']);
    });
  }

  onCambioProductoRealizado() {
    this.buscar(this.paginationContext.CurrentPage);
  }

  //MOSTRAR Y EDITAR NOTA DE VENTA SELECCIONADA
  OnEditNotaVenta(mov) {
    this.ValidateNotaVenta = true;
    this.modalConfirmTitle = 'Editar Nota de Venta';
    this.modalConfirmContent = '¿Desea editar la nota de venta ' + mov.folio + '?';
    this.modalConfirm.show(() => {
      this.RedireccEditNotaVenta(mov.folio);
    });
  }

  RedireccEditNotaVenta(folio) {
    this.folio = folio;
    this.showEdit = true;
    this.obtenerNotaVentaEsp(this.folio);
    // this.CargarData();
  }

  obtenerNotaVentaEsp(folio) {
    const inputParams = {
      entidad: {
        folio: folio,
      },
    };

    this.notaventaService.ObtenerDataEspNotaVenta(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { cabecera, detalle } = respuesta;

      const data = JSON.parse(respuesta.documento);
      data.folio = respuesta.folio;
      this.seleccionNotaVentaEsp = data;
      this.notaVenta.LoadAndShow(this.seleccionNotaVentaEsp, true);
    });
  }

  // async CargarData(){
  //   const result = await this.resolveAfter2Seconds();
  //  }

  //  resolveAfter2Seconds() {
  //   return new Promise(resolve => {
  //     setTimeout(() => {

  //     }, 100);
  //   });
  // }

  //CERRAR VEMTANA DE AGREGAR O EDITAR NOTA VENTA
  OnCloseEditAdd(validarNotaVenta) {
    if (validarNotaVenta) {
      this.ValidateNotaVenta = !validarNotaVenta;
    } else {
      this.ValidateNotaVenta = false;
    }
    this.showEdit = false;
    this.buscar(1);
  }

  onUpdateFiltro() {
    this.ValidateNotaVenta = false;
    this.showEdit = false;
    this.buscar(1);
  }
}
